import { getTrailers } from "@/services/trailer-service";
import { TrailerType } from "@/types/TrailerType";
import { keepPreviousData, useQuery } from "@tanstack/react-query";
import ms from "ms";

const useTrailers = (gameId: string) => {
    return useQuery<TrailerType[], Error>({
        queryKey: ['trailers', gameId],
        queryFn: () => getTrailers(gameId), // Pass a function reference
        placeholderData: keepPreviousData,
        staleTime: ms('24h')
    })
};

export default useTrailers;
